
import React, {  useEffect, useState } from "react";


import ProDropDown from "../common/ProDropDown";
import ProCalendar from "../common/ProCalendar";
import ProInputNumber from "../common/ProInputNumber";
import ProFormFooter from "../common/ProFormFooter";
import ProInputText from "../common/ProInputText";
import ProAutoComplete from "../common/ProAutoComplete";
import ProPanelWithAccordion from "../common/ProPanelWithAccordion";
import ProCensusMoveClientForm from "./ProCensusMoveClientForm";

import useFormModelServices from "../../hooks/useFormModelServices";
import useFormServices from "../../hooks/useFormServices";
import useCensus from "../../hooks/useCensus";
import useCensusForm from "../../hooks/useCensusForm";
import { useClientService } from "../../hooks/useClientService";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import { useFormik } from "formik";

import CensusFormValidator from "./validator/CensusFormValidator";
import { ReserveOrAssignBedModel } from "../../models/FormDataModel";
import { AddDays, FormattedDateString, FormattedToday } from "../../utilities/DateHelper";
import { OccupantTypeOptions } from "../../constants/ProConstants";
import { Confirm } from "../../utilities/ProDialogs";
import _ from 'lodash'



const ProCensusForm = ({formModel, formAction, closeSideBar})=>{      
   
    const [isMounted, setIsMounted] = useState(false)
    const {data: {filter, clientStatus}, actions: {AssignOrReserveBed, MoveClient, SetClientStatus}} = useCensus({refreshTree:false}); 
    const {data:{selectedTreeNode}} = useHierarchyService();   
   
    const {filteredClient, SearchClient} = useClientService();
    const isFieldDisabled = _.isEmpty(formModel) ? false: true
    const {InitializeMoveClient } = useFormModelServices();  
    const {actions:{Initialize, ConfirmFormAction, UpdateFormState}} = useFormServices()
    
    const GetModel = ()=>{
        var model = _.isEmpty(formModel)? ReserveOrAssignBedModel: _.isEqual(formAction, "MOVE")?InitializeMoveClient(formModel): formModel
        model = {...model, date:FormattedDateString(filter.date), startDate:_.isNull(model.startDate)?filter.date : model.startDate,
             endDate:_.isNull(model.endDate)?AddDays(_.isNull(model.startDate)?filter.date : model.startDate, 1):model.endDate,
             action: formAction, bedId: selectedTreeNode.id}      
        return model;
    }
 
   
    useEffect(()=>{         
        if(!isMounted){
            setIsMounted(true);           
            Initialize(closeSideBar)
            SetClientStatus([])
            _.isEqual(formAction, "ASSIGN") && UpdateFormState(true)
        }
        if(isMounted){            
            ConfirmFormAction();            
        }      
            
    }, [selectedTreeNode])

    useEffect(()=>{
        return ()=>{  
            UpdateFormState(false)                   
        }
    }, [])
   

    const formik = useFormik({
        initialValues:  GetModel(),        
        validate: (data) => {
            return CensusFormValidator(data, SetClientStatus)           
        },
        onSubmit: (data) => {           
           handleSubmit(data);
           formik.resetForm();
           closeSideBar();
        },
    });

    const {actions:{onChanged}} = useCensusForm({formik})
   

    const handleSubmit = async (data)=>{
        switch(formAction){
            case "ASSIGN":
            case "RESERVE": 
            case "EDIT_ASSIGN":           
                await AssignOrReserveBed(data);               
                break; 
            case "MOVE":
                console.log(data)
                Confirm(async()=>{await MoveClient(data);},
                        ()=>{},
                        _.isEqual(data.occupantType.code, "CLIENT")?
                        `Move ${data.client.lastName}, ${data.client.firstName} to Bed ${data.building.name} > ${data.room.name} > ${data.bed.name}?\nDependents assigned to beds must be moved separately.`
                        :`Move ${data.dependentName} to Bed ${data.building.name} > ${data.room.name} > ${data.bed.name}?\nDependents assigned to beds must be moved separately.`)  
                
                break;
            default:
                break;
        }
    }
   

    return (
        <form onSubmit={formik.handleSubmit}>
            <ProDropDown
                headerText="Occupant Type"
                id="occupantType"
                value={formik.values.occupantType}
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                onChange={onChanged}
                options={OccupantTypeOptions} 
                optionLabel="name"
                placeholder="Occupant"
                formik={formik}
                error = "occupantType"
                disabled = {isFieldDisabled}
                required
            />    
           
            <ProAutoComplete
                id="client"                    
                labelText="Client"
                field = "fullName"
                formik = {formik}
                minLength={3}
                multiple={false}
                value={formik.values.client}
                suggestions = {filteredClient}
                completeMethod = {SearchClient}                        
                onChange={onChanged}
                error = "client"
                disabled = {isFieldDisabled}
                required
                    />               
           {(_.get(formik.values.occupantType, "code") === "DEPENDENT") && <ProInputText               
                id="dependentName"
                labelText="Dependent Name"
                value={formik.values.dependentName}
                onChange={onChanged}
                formik={formik}
                error="dependentName" 
                disabled = {!_.includes( ["EDIT_ASSIGN", "ASSIGN", "RESERVE"], formAction)}
                required                
                />    }                  
            <ProCalendar 
                id="startDate" 
                placeholder="Start Date"
                value = {formik.values.startDate}
                onChange={onChanged}                
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                formik={formik}               
                maxDate= {_.includes( ["RESERVE"], formAction)?null : FormattedToday}
                minDate= {_.includes( ["RESERVE"], formAction)?FormattedToday : null}
                error = "startDate"
                disabled = {_.includes( ["MOVE"], formAction)}
                required               
               />   
            <ProCalendar 
                id="endDate" 
                placeholder="End Date"
                value = {formik.values.endDate}
                onChange={onChanged}                
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                formik={formik}
                error = "endDate"
                minDate= {AddDays(formik.values.startDate, 1)}   
                disabled = {_.includes( ["MOVE"], formAction)}              
                required/>  
            <ProInputNumber
                id="stayDuration"
                labelText="Length Of Stay"                
                value={formik.values.stayDuration}
                onChange={onChanged}
                formik={formik}
                placeholder="Duration"
                error="stayDuration"
                minValue = {1}   
                disabled = {_.includes( ["MOVE"], formAction)}            
                required
                /> 
            {_.isEqual(formAction, "MOVE") &&  <ProCensusMoveClientForm formik={formik} onChanged={onChanged}/> }
            {_.includes(["RESERVE", "ASSIGN"], formAction) && _.gt(clientStatus.length, 0) && 
                _.map(clientStatus, (c,index)=>{                                             
                        return <div key={index}>
                                <h6 style={{marginLeft:"5px", marginTop:"10px"}}>{c.type}</h6>
                                <ProPanelWithAccordion  type= {c.type} data={c.details}/>
                            </div>                       
                }) 
            }
            <ProFormFooter onSave={() => console.log("Save")}  onCancel={closeSideBar} enableOnDirty={formik.dirty ||_.isEqual(formAction, "ASSIGN") } />                     
        </form>
    )



}

export default ProCensusForm;